import { ServerError } from "@repo/chameleon-request";
import { configureNextServerRequest } from "@repo/next-utils/next-server-request";
import {
  getSitecoreDatasource,
  getSitecoreGraphEndpoint,
} from "@repo/sitecore-lib/utils";
import { SITEBANNER_QUERY } from "./query";
import type { SiteBannerResponse } from "./site-banner.type";

export type GetSiteBannerParams = {
  requestInstance: ReturnType<typeof configureNextServerRequest>;
  shop: string;
  language: string;
};

export const getSiteBanner = async (
  params: GetSiteBannerParams,
): Promise<SiteBannerResponse> => {
  const { requestInstance, shop, language } = params;

  const url = getSitecoreGraphEndpoint(
    process.env.SITECORE_GRAPH_API_HOST || undefined,
  );
  const datasource = getSitecoreDatasource({
    shop,
    itemName: "Site Banners",
  });

  try {
    const response = await requestInstance.post<SiteBannerResponse>(
      url,
      {
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: SITEBANNER_QUERY,
          variables: {
            datasource,
            language,
          },
        }),
      },
      {
        requestType: "SITECORE_BANNER_GRAPHQL",
      },
    );

    return response.data;
  } catch (error) {
    if (error instanceof ServerError) {
      return {};
    }
    throw error;
  }
};
